import AbstractScene from './AbstractScene.js';
import UI from './UI.js';

export default class Preloader extends AbstractScene {

    constructor() {
        super({
            key: "Preloader"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();

        // Ajout du texte de chargement
        this.loadingText = this.make.text({
            x: this.width / 2,
            y: this.height / 2,
            text: 'Chargement... 0%',
            style: {
                font: '60px MassiliaMedium',
                fill: '#000000',
                stroke: '#FFF',
                strokeThickness: 8
            }
        });

        this.loadingText.setOrigin(0.5, 0.5);

        this.loadSprites();

        this.load.on('progress', (value) => {
            // this.chargement.setScale(value, 1);
            this.loadingText.text = 'Chargement... ' + Math.floor(value * 100) + '%';
        });
        
        // this.load.on('fileprogress', function (file) {
            // console.log(file.src);
        // });

        this.load.on('complete', function () {
            this.scene.add('UI', UI, true);
            this.nextScene();
        }, this);
    }

    loadSprites() {
        this.load.html('videoPlayer', 'assets/videos/video.html');

        this.load.image('intro', "assets/images/menu/image_menu.png")
        this.load.image('mqde', "assets/images/menu/mqde.png")
        this.load.image('rectIntro', "assets/images/menu/rect_menu.png")
        this.load.image('logoABC', "assets/images/menu/logo_abc.png")
        this.load.image('logoMQDE', "assets/images/menu/logo_mqde_couleur.png")
        this.load.image('logoBDF', "assets/images/menu/logo_bdf.png")
        this.load.image('logoSydo', "assets/images/menu/logo_sydo.png")
        this.load.image('backFin', 'assets/images/menu/back_fin.png')
        this.load.image('backLine', 'assets/images/menu/back_line.png')
        this.load.image('logoLinkedin', 'assets/images/menu/logo_linkedin.png')


        this.load.image('imgPlaceholder', 'assets/images/communs/img-placeholder.png')
        this.load.image('imgPlaceholderBig', 'assets/images/communs/img-placeholder-big.png')
        this.load.image('labelPlaceholder', 'assets/images/communs/label-placeholder.png')
        this.load.image('badAnswer', 'assets/images/communs/bad-answer.png')
        this.load.image('goodAnswer', 'assets/images/communs/good-answer.png')
        this.load.image('goodBox', 'assets/images/communs/good-box.png')
        this.load.image('badBox', 'assets/images/communs/bad-box.png')

        // Assets Game 1
        this.load.image('icon_cercle_egale', 'assets/images/game1/icon_cercle_egale.png')
        this.load.image('icon_cercle_moins_orange', 'assets/images/game1/icon_cercle_moins_orange.png')
        this.load.image('icon_cercle_moins_bleu', 'assets/images/game1/icon_cercle_moins_bleu.png')
        this.load.image('zone_dettes', 'assets/images/game1/zone_dettes.png')
        this.load.image('zone_liquidite', 'assets/images/game1/zone_liquidite.png')
        this.load.image('zone_rectangulaire', 'assets/images/game1/zone_rectangulaire.png')
        this.load.image('caisseNoir', 'assets/images/game1/cards/caisse-black.png')
        this.load.image('decouvertNoir', 'assets/images/game1/cards/decouvert-black.png')
        this.load.image('compteBancaireNoir', 'assets/images/game1/cards/compte-bancaire-black.png')
        this.load.image('fondRoulementNoir', 'assets/images/game1/cards/fond-roulement-black.png')
        this.load.image('besoinFondRoulementNoir', 'assets/images/game1/cards/besoin-fonds-black.png')
        this.load.image('caisse', 'assets/images/game1/cards/caisse.png')
        this.load.image('decouvert', 'assets/images/game1/cards/decouvert.png')
        this.load.image('compteBancaire', 'assets/images/game1/cards/compte-bancaire.png')
        this.load.image('fondRoulement', 'assets/images/game1/cards/fond-roulement.png')
        this.load.image('besoinFondRoulement', 'assets/images/game1/cards/besoin-fonds.png')
        
        // Assets Game 2
        this.load.image('backGame2', 'assets/images/game2/background.png')
        this.load.image('batiment', 'assets/images/game2/cards/batiment.png')
        this.load.image('creance', 'assets/images/game2/cards/creances_clients.png')
        this.load.image('dettes', 'assets/images/game2/cards/dettes_fournisseur.png')
        this.load.image('emprunt', 'assets/images/game2/cards/emprunts_bancaires.png')
        this.load.image('fonds', 'assets/images/game2/cards/fonds_de_commerce.png')
        this.load.image('materiel', 'assets/images/game2/cards/materiel.png')
        this.load.image('ressource', 'assets/images/game2/cards/ressources_stables.png')
        this.load.image('resultats', 'assets/images/game2/cards/resultats.png')
        this.load.image('stock', 'assets/images/game2/cards/stocks.png')
        this.load.image('batimentNoir', 'assets/images/game2/cards/batiment_noir.png')
        this.load.image('creanceNoir', 'assets/images/game2/cards/creances_clients_noir.png')
        this.load.image('dettesNoir', 'assets/images/game2/cards/dettes_fournisseur_noir.png')
        this.load.image('empruntNoir', 'assets/images/game2/cards/emprunts_bancaires_noir.png')
        this.load.image('fondsNoir', 'assets/images/game2/cards/fonds_de_commerce_noir.png')
        this.load.image('materielNoir', 'assets/images/game2/cards/materiel_noir.png')
        this.load.image('ressourceNoir', 'assets/images/game2/cards/ressources_stables_noir.png')
        this.load.image('resultatsNoir', 'assets/images/game2/cards/resultats_noir.png')
        this.load.image('stockNoir', 'assets/images/game2/cards/stocks_noir.png')

        // Assets Game 3
        this.load.image('backGame3', 'assets/images/game3/background3.png')
        this.load.image('deck', 'assets/images/game3/fond_deck.png')
        this.load.image('besoinTresorerie', 'assets/images/game3/besoin_tresorerie.png')
        this.load.image('besoinTresorerieFalse', 'assets/images/game3/besoin_tresorerie_false.png')
        this.load.image('besoinTresorerieTrue', 'assets/images/game3/besoin_tresorerie_true.png')
        this.load.image('schemaBesoinTresorerie', 'assets/images/game3/schema_besoin_tresorerie.png')
        this.load.image('schemaBesoinTresorerieFalse', 'assets/images/game3/schema_besoin_tresorerie_false.png')
        this.load.image('schemaBesoinTresorerieTrue', 'assets/images/game3/schema_besoin_tresorerie.png')
        this.load.image('excedentTresorerie', 'assets/images/game3/excedent_tresorerie.png')
        this.load.image('excedentTresorerieFalse', 'assets/images/game3/excedent_tresorerie_false.png')
        this.load.image('excedentTresorerieTrue', 'assets/images/game3/excedent_tresorerie_true.png')
        this.load.image('schemaExcedentTresorerie', 'assets/images/game3/schema_excedent_tresorerie.png')
        this.load.image('schemaExcedentTresorerieFalse', 'assets/images/game3/schema_excedent_tresorerie_false.png')
        this.load.image('schemaExcedentTresorerieTrue', 'assets/images/game3/schema_excedent_tresorerie.png')
        this.load.image('badAnswer3', 'assets/images/game3/bad-answer.png')
        this.load.image('placeholder3_1', 'assets/images/game3/placeholder_1.png')
        this.load.image('placeholder3_3', 'assets/images/game3/placeholder_3.png')
        this.load.image('placeholder3_4', 'assets/images/game3/placeholder_4.png')
    
        // Assets Game 4
        this.load.image('titre4', 'assets/images/game4/titre.png')
        this.load.image('bfr', 'assets/images/game4/bfr.png')
        this.load.image('fr', 'assets/images/game4/fr.png')
        this.load.image('centre', 'assets/images/game4/centre.png')
        this.load.image('augmenter_ca', 'assets/images/game4/augmenter_ca.png')
        this.load.image('perte_controle', 'assets/images/game4/perte_controle.png')
        this.load.image('niveau_endettement', 'assets/images/game4/niveau_endettement.png')
        this.load.image('perso', 'assets/images/game4/perso.png')

        this.load.image('augmenter_capital', 'assets/images/game4/cards/augmenter_capital.png')
        this.load.image('reduire_delais', 'assets/images/game4/cards/reduire_delais.png')
        this.load.image('maintenir_benefices', 'assets/images/game4/cards/maintenir_benefices.png')
        this.load.image('negocier_delais', 'assets/images/game4/cards/negocier_delais.png')
        this.load.image('souscrire_emprunts', 'assets/images/game4/cards/souscrire_emprunts.png')
        this.load.image('limiter_stocks', 'assets/images/game4/cards/limiter_stocks.png')

        this.load.image('augmenter_capital_placeholder', 'assets/images/game4/cards/placeholder_augmenter_capital.png')
        this.load.image('reduire_delais_placeholder', 'assets/images/game4/cards/placeholder_reduire_delais.png')
        this.load.image('maintenir_benefices_placeholder', 'assets/images/game4/cards/placeholder_maintenir_benefices.png')
        this.load.image('negocier_delais_placeholder', 'assets/images/game4/cards/placeholder_negocier_delais.png')
        this.load.image('souscrire_emprunts_placeholder', 'assets/images/game4/cards/placeholder_souscrire_emprunts.png')
        this.load.image('limiter_stocks_placeholder', 'assets/images/game4/cards/placeholder_limiter_stocks.png')

        this.load.image('fond_5', 'assets/images/game4/creances.png')
        this.load.image('fond_6', 'assets/images/game4/dettes.png')
        this.load.image('fond_3', 'assets/images/game4/emprunt.png')
        this.load.image('fond_2', 'assets/images/game4/ressources.png')
        this.load.image('fond_1', 'assets/images/game4/resultats.png')
        this.load.image('fond_4', 'assets/images/game4/stocks.png')

    }
}